export enum ProductType {
  SavingsorCurrent = 0,
  FixedDeposit,
  Loan,
  MortgageLoan,
  GroupLoan,
  CommitmentSavings,
}
